@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.preview-title {
  font-weight: @bold;
  margin-bottom: 15px;
}

.pill-row {
  margin: 10px 0;
  font-size: small;
  vertical-align: center;
}

.pill-title {
  padding-top: 6px;
  display: inline-block;
  margin-left: 5px;
}

.no-summary {
  font-style: italic;
  font-size: small;
  color: @carrier-pickup--modal-fulfillment--text-color;
}
